import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout";

// Components
import { DashboardHeader } from "./DashboardHeader";
import { DashboardStats } from "./DashboardStats";

// Tabs
import { TodaysRvsTab } from "./TodaysRvsTab";
import { RecentRvsTab } from "./RecentRvsTab";
import { NewPatientsTab } from "./NewPatientsTab";
import { PendingTasksTab } from "./PendingTasksTab";

// Hooks
import { useRvs } from "../../hooks/useRv";
import { usePendingTasks } from "../../hooks/usePendingTasks";

const Dashboard: React.FC = () => {
  useEffect(() => {
    const savedTheme = localStorage.getItem("app-theme") || "teal";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const [activeTab, setActiveTab] = useState("today");
  
  // 1. Πρόσθεσε state για το pending subtab εδώ στο Dashboard
  const [pendingSubTab, setPendingSubTab] = useState<"gdpr" | "documents">("gdpr");

  const { dayRvs = [], monthRvs = [], newPatientsRvs = [], fetchByDay, fetchByMonth, fetchNewPatients } = useRvs();

  const { gdprNoConsentList = [], documentsWithNoFileList = [] } = usePendingTasks();

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    
    fetchByDay(`${year}-${month}-${day}`);
    fetchByMonth(year, Number(month));
    fetchNewPatients();
  }, [fetchByDay, fetchByMonth, fetchNewPatients]);
  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "today":
        return <TodaysRvsTab />;
      case "recent":
        return <RecentRvsTab />;
      case "new":
        return <NewPatientsTab />;
      case "pending":
        return (
          <PendingTasksTab 
            pendingSubTab={pendingSubTab} 
            setPendingSubTab={setPendingSubTab} 
          />
        );
      default:
        return <TodaysRvsTab />;
    }
  };

  return (
    <Layout>
      <DashboardHeader />
      <DashboardStats 
        onSelectTab={setActiveTab}
        recentCount={monthRvs.length}
        todayCount={dayRvs.length}
        newCount={newPatientsRvs.length}
        pendingCount={gdprNoConsentList.length + documentsWithNoFileList.length}
      />
      {renderActiveTabContent()}
    </Layout>
  );
};

export default Dashboard;
